// Installations page - lists all works with an id field (i.e. those that have a dedicated page)

import { Link } from 'react-router-dom';
import useReveal from '../components/useReveal';
import { works } from '../data/works';
// import movementsImage from '../data/images/movements-work.jpeg';


function Reveal({ children, delay = 0, className = '' }) {
  const ref = useReveal();
  return <div ref={ref} className={`reveal ${className}`} style={{ transitionDelay: `${delay}ms` }}>{children}</div>;
}

export default function Installations() {
  // Filter to show only installations/works (those with an id field)
  const installations = works
  .filter(w => w.id && w.id.trim() !== '')
  .sort((a,b) => new Date(b.date) - new Date(a.date));

  return (
    <div className="pt-16 bg-cream-100 min-h-screen">

      {/* Header */}
      <div className="px-10 md:px-20 py-28 border-b border-cream-400/60">

        <p className="label mb-6">
          Installations
        </p>

        <h1 className="font-serif text-6xl md:text-7xl max-w-4xl leading-none mb-10">
          Selected works exploring
          sensing, interaction
          and physical space.
        </h1>

        <p className="max-w-xl font-sans text-stone-warm leading-relaxed">
          These works investigate how technology can reveal
          invisible relationships between people, spaces and
          the environments they inhabit.
        </p>

      </div>

      {/* Installations list */}
      <div className="divide-y divide-cream-400/60">
        {installations.map((inst, i) => (
          <InstallationRow key={inst.id} works={inst} index={i} />
        ))}
      </div>

      {/* How it works */}
      <div className="border-t border-cream-400/60 px-10 md:px-16 lg:px-20 py-20 ">
        <Reveal><p className="label text-stone-muted mb-12">How each work is made</p></Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#F8F3D6] shadow-[0_0_80px_rgba(255,220,120,0.48)] border border-cream-400/60">
          {[
            { step: '01', title: 'Sense', body: 'Gather data from spaces and body- from things and people, from product and processes.' },
            { step: '02', title: 'Deploy', body: 'The physical space that it sits within' },
            { step: '03', title: 'Communicate', body: 'Raw sensor data is mapped in real time to visual, sonic, or structural parameters through custom algorithms.' },

          ].map(({ step, title, body }) => (
            <Reveal key={step}>
              <div className="bg-cream-100 p-10 h-full">
                <span className="font-mono text-[10px] text-stone-muted tracking-widest2 block mb-8">{step}</span>
                <h3 className="font-serif text-2xl text-ink font-normal mb-4">{title}</h3>
                <p className="font-sans text-sm text-stone-warm leading-relaxed">{body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Commission CTA */}
      <div className="border-t border-cream-400/60 px-10 md:px-16 lg:px-20 py-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <p className="font-serif text-2xl text-ink font-normal">Interested in commissioning a work?</p>
        <a href="mailto:kedlayaananya@gmail.com"
          className="label border border-stone-muted bg-[#F8F3D6] text-ink px-6 py-3 hover:bg-cream-50 transition-colors">
          Get in touch →
        </a>
      </div>
    </div>
  );
}

function InstallationRow({ works, index }) {
  const ref = useReveal();

return (
  <article
    ref={ref}
    className="reveal border-t border-cream-400/60 py-20"
  >
    <div className="max-w-6xl mx-auto px-10 md:px-16 lg:px-20">

      {/* <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16 items-start"> */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 xl:gap-24 items-start">

        {/* Number */}
        <div className="hidden md:flex md:col-span-1 justify-center">
          <span className="font-serif text-[7rem] lg:text-[6rem] leading-none text-[#e0bf58] select-none">
          
            {String(index + 1).padStart(2, "0")}
          </span>
        </div>

        {/* Text */}
        <div className="md:col-span-7">

          <h2 className="font-serif text-4xl md:text-5xl leading-tight text-ink mb-5">
            {works.title}
          </h2>

          <p className="font-sans text-base leading-relaxed text-stone-warm max-w-xl mb-10">
            {works.description}
          </p>

          <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-stone-muted mb-10">

            {works.location && <span>{works.location}</span>}
            {works.year && <span>{works.year}</span>}
            {works.output && <span>Output: {works.output}</span>}

          </div>

          {works.technology?.length > 0 && (
            <div className="flex flex-wrap gap-2 mb-10">
              {works.technology.map(t => (
                <span
                  key={t}
                  className="label border border-cream-400/60 px-2 py-1 bg-[#F8F3D6] text-ink"
                >
                  {t}
                </span>
              ))}
            </div>
          )}

          {(works.blogId || works.writingId) && (
            <Link
              to={`/blog/${works.blogId || works.writingId}`}
              className="label border-b border-ink pb-0.5 hover:opacity-60 transition-opacity"
            >
              Read Journal →
            </Link>
          )}

        </div>

        {/* Graphic */}
        <div className="md:col-span-4">

          {/* <Link
            // to={`/installations/${works.id}`}
            //  to={`/installations/${works.id}`}
             to={`/blog/${works.id}`}
            className="group block"
          > */}
            <div className="aspect-square border border-cream-400/60 flex items-center justify-center hover:bg-cream-200/30 transition-colors">

              {/* <img src={`./data/images/${works.id}.jpeg`} alt={works.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200" />   */}
              <img src={works.coverImage } alt={works.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200" />
            </div>

            {/* <p className="label mt-4 text-center group-hover:opacity-60 transition-opacity">
              View work
            </p> */}

          {/* </Link> */}

        </div>

      </div>

    </div>
  </article>
);
}
